module.exports = __webpack_public_path__ + "static/media/medicalcare.f5cb6925.png";